import { TABLA_CAMIONES_CALADO } from '../../../../../../config/tables'
import { COLUMNS_CAMIONES_CALADO, COLUMNS_CAMIONES_CALADO_TO_PRINT } from './constantesCamionesCalados'
import { TablaCamionesCaladosService } from '../servicio/tabla_camiones_calados'
import CargaEntranteAutomotorCalado from '../../../../../../models/calado/carga_entrante_automotor_calado'
import { pdfCustomToolbarGenerator } from '../../../../../../models/tools/generarPdf'
import ConsultaCea from '../../../../../../models/calado/consulta_cea'
import Cpa from '../../../../../../models/camiones/cpa'
import { setModoIngreso, updateProcesoCalado, consultaCalificacionPorCalleCalado, consultaEstadoOcupacionCallesCalado } from '../../../../../Calado/actions'
import { openDialogHuella, closeDialogHuella, obtenerHuellaDigital } from '../../../../../Huella/actions'
import { toast } from 'react-toastify'
import CpaPresunta from '../../../../../../models/camiones/cpa_presunta'

export function actualizarDatosParaMuiTable (filtroInicial = null) {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_CAMIONES_CALADO
    })

    TablaCamionesCaladosService.getDataCamionesCalados().then(callback)
    function callback (result) {
      const data = []
      result.forEach(d => { data.push({ ...d, cartadeporte: d.cartaDePorteAutomotor }) })
      //  const columnas = getColumnasCamionesCalados(rol)
      const customToolbar = pdfCustomToolbarGenerator(
        'Camiones calados',
        data,
        COLUMNS_CAMIONES_CALADO_TO_PRINT,
        'landscape'
      )
      const textRowCount = 'Cantidad de camiones: '
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_CAMIONES_CALADO,
          data: data,
          title: `Camiones calados`,
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: {
            customToolbar,
            print: false,
            pagination: false,
            tableBodyMaxHeight: '450px',
            filtroInicial: filtroInicial,
            showRowCount: true,
            textRowCount
          }
        },
        id: TABLA_CAMIONES_CALADO
      })
    }
  }
}

export function getConsultaCea (numero, callback) {
  return dispatch => {
    dispatch({ type: 'REQUEST_CONSULTA_CEA' })
    ConsultaCea.getById(numero)
      .then(consultaCea => {
        dispatch({ type: 'RECEIVE_CONSULTA_CEA', consultaCea })
        callback && callback(consultaCea)
      })
      .catch(_ => dispatch({
        type: 'RECEIVE_CONSULTA_CEA',
        consultaCea: null
      }))
  }
}

export function requestDatosConsultaCpa (numero, callback) {
  return (dispatch) => {
    dispatch({ type: 'REQUEST_CONSULTA_CPA' })
    Cpa.getConsultaById(numero)
      .then(cpa => {
        dispatch({ type: 'RECEIVE_CONSULTA_CPA', cpa })
        callback && callback(cpa)
      })
  }
}

export function dialogHuella (tipo) {
  return async (dispatch) => {
    dispatch(openDialogHuella(tipo))
    const data = await obtenerHuellaDigital(tipo)
    console.log('Huella data', data)
    dispatch(closeDialogHuella())
    return data
  }
}

export function updateHumedad (newValue) {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_HUMEDAD',
      newValue
    })
  }
}

export function updateConsultaCea (newValue) {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_CONSULTA_CEA',
      newValue
    })
  }
}

export function updateSiloAparte (newValue) {
  return (dispatch) => {
    return dispatch({ type: 'UPDATE_SILO_APARTE', newValue })
  }
}

export function updateFumigado (newValue) {
  return (dispatch) => {
    return dispatch({ type: 'UPDATE_FUMIGADO', newValue })
  }
}

export function updatePendienteAutorizar (newValue) {
  return (dispatch) => {
    return dispatch({ type: 'UPDATE_PENDIENTE_AUTORIZAR', newValue })
  }
}

export function setModo (cereal, modo) {
  return (dispatch) => {
    return dispatch(setModoIngreso(cereal, modo))
  }
}

export function updateProceso (perito, callback) {
  return (dispatch) => {
    return dispatch(updateProcesoCalado(perito, callback))
  }
}

export function consultaEstadoOcupacionCalles () {
  return (dispatch) => {
    return dispatch(consultaEstadoOcupacionCallesCalado())
  }
}

export function consultaCalificacionPorCalle () {
  return (dispatch) => {
    return dispatch(consultaCalificacionPorCalleCalado())
  }
}

export function rechazarEnAfip (numero) {
  return dispatch => {
    dispatch({ type: 'SHOW_CIRCULAR' })
    dispatch({ type: 'RECHAZAR_CPE_EN_ARCA' })
    Cpa.getById(numero)
      .then(cpa => {
        if (cpa && cpa.estadoCtg === 'V') {
          CargaEntranteAutomotorCalado.rechazarCpeEnAfip(cpa.cpeSucursal, cpa.cpeSecuencia, cpa.cuentayorden)
            .then(data => {
              dispatch({ type: 'RECEIVE_RECHAZAR_CPE_EN_ARCA', data })
              // deberia devolver 'R'
              const estadoData = data.rechazarcpe.substr(1, data.rechazarcpe.length - 2).split(',')
              console.log('estado', estadoData)
              if (estadoData[0] === 'R') { // 'R'
                Cpa.cambiarEstadoCtg(numero, 'A')
                  .then(data => {
                    toast.info('Se rechazó la carta de porte en ARCA')
                    dispatch(actualizarDatosParaMuiTable())
                    dispatch({ type: 'HIDE_CIRCULAR' })
                    console.log('estado_ctg actualizado', data)
                  })
              } else {
                toast.info(estadoData[1])
                dispatch(actualizarDatosParaMuiTable())
                dispatch({ type: 'HIDE_CIRCULAR' })
              }
            })
        } else {
          toast.info('Verifique el estado del CTG')
          dispatch(actualizarDatosParaMuiTable())
          dispatch({ type: 'HIDE_CIRCULAR' })
        }
      })
      .catch((error) => {
        console.log(error)
        dispatch({ type: 'HIDE_CIRCULAR' })
      })
  }
}

// TODO: Ver si es necesario actualizar tambien transportista y chofer
export function actualizarDesdeAfip (numero) {
  return dispatch => {
    dispatch({ type: 'ACTUALIZAR_CPE_DESDE_ARCA' })
    CpaPresunta.getById(numero)
      .then(presunta => {
        if (presunta && presunta.numero) {
          Cpa.getById(numero)
            .then(cpa => {
              if (presunta.camion === cpa.camion &&
                presunta.acoplado === cpa.acoplado) {
                toast.info(`La CPE ${numero} no presenta cambios en ARCA`)
              } else {
                dispatch({ type: 'SHOW_CIRCULAR' })
                console.log('presunta', presunta)
                if (presunta && presunta.numero) {
                  Cpa.actualizarDesdePresunta(numero, presunta.camion, presunta.acoplado)
                    .then(result => {
                      // dispatch(forzarConfirmarArribo(numero))
                      Cpa.validarCpeEnAfip(cpa.cpeSucursal, cpa.cpeSecuencia, cpa.cuentayorden)
                        .then(confirmarArribo => {
                          dispatch({ type: 'RECEIVE_VALIDAR_CPE_EN_ARCA', confirmarArribo })
                          // deberia devolver 'V'
                          console.log('confirmacion', confirmarArribo)
                          if (confirmarArribo && !confirmarArribo.error) {
                            const estadoData = confirmarArribo.validarcpe.substr(1, confirmarArribo.validarcpe.length - 2).split(',')
                            if (estadoData[0] === 'V') { // 'V'
                              Cpa.cambiarEstadoCtg(numero, 'V')
                                .then(data => {
                                  console.log('Estado cambiado a V')
                                  toast.info('Confirmado en ARCA')
                                  dispatch(actualizarDatosParaMuiTable())
                                  dispatch({ type: 'HIDE_CIRCULAR' })
                                })
                            } else {
                              toast.info(estadoData[2])
                              dispatch(actualizarDatosParaMuiTable())
                              dispatch({ type: 'HIDE_CIRCULAR' })
                            }
                          } else {
                            toast.error('Hubo problemas al confirmar arribo en ARCA')
                            dispatch({ type: 'HIDE_CIRCULAR' })
                          }
                        })
                    })
                } else {
                  toast.error('Hubo problemas al actualizar la CPE desde ARCA')
                  dispatch({ type: 'HIDE_CIRCULAR' })
                }
              }
            })
        } else {
          toast.error('Hubo problemas al actualizar la CPE desde ARCA')
          dispatch({ type: 'HIDE_CIRCULAR' })
        }
      })
      .catch((error) => {
        console.log(error)
        dispatch({ type: 'HIDE_CIRCULAR' })
      })
  }
}
